const state = {
  reviewsAnswerId: null,
  preguntas: [],
  tiempoDisponible: 0,
  resultado: null,
  evaluacionActiva: false
}

export default state
